// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"2da790ee","144":"c252d132","258":"eac67733","426":"f5720a8d","623":"eb8e3e00","961":"a4dc5b8f"}[chunkId] + ".chunk.css";
};